export default {"src":"/_next/static/media/shopping-cart-v2-icon.47df8e85.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};